import "./LoadingIndicator.scss";

export const LoadingIndicator = () => (
  <div className="LoadingIndicator">
    <div className="LoadingIndicator__ball"></div>
    <div className="LoadingIndicator__ball"></div>
  </div>
);
